import React from 'react'

export default class ModalConfirmacaoCancelamentoEncomendaAvulsa extends React.Component {
  constructor (props) {
    super(props)
    this.state = { motivo: '', erro: null }
  }

  confirmar () {
    if (!this.state.motivo.trim()) {
      this.setState({ erro: 'Informe o motivo do cancelamento.' })
      return
    }
    this.props.onConfirmar(this.state.motivo)
  }

  render () {
    return (
      <React.Fragment>
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
              <div className="vx-modal-header">
                <div className="vx-modal-title">
                  <span className="material-icons">delete</span>
                  Cancelar encomenda avulsa
                </div>
                <button type="button" className="vx-modal-close" aria-label="Close" onClick={this.props.onFechar}>
                  <span className="material-icons">close</span>
                </button>
              </div>
              <div className="vx-modal-body" style={{ background: '#fff' }}>
                <p>Deseja realmente cancelar esta encomenda avulsa?</p>
                <div className="form-group">
                  <label>Motivo do cancelamento</label>
                  <textarea className="form-control" rows="2" value={this.state.motivo}
                            onChange={event => this.setState({ motivo: event.target.value, erro: null })}/>
                  {this.state.erro && <small className="text-danger">{this.state.erro}</small>}
                </div>
              </div>
              <div className="vx-modal-footer">
                <button type="button" className="vx-modal-btn-fechar" onClick={this.props.onFechar}>Não, voltar</button>
                <button type="button" className="vx-modal-btn-confirmar" onClick={() => this.confirmar()}>
                  <span className="material-icons" style={{ fontSize: 15 }}>check</span>
                  Sim, cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show"/>
      </React.Fragment>
    )
  }
}
